import type { FormKitTypeDefinition } from '@formkit/core'
import { createInput } from '@formkit/vue'
import type { MaybeRef } from 'vue'
import type { FormKitOptionsItem } from '@formkit/inputs'
// import type { MultiSelectChangeEvent } from 'primevue/multiselect'

export const MultiSelect: FormKitTypeDefinition = createInput(
  {
    $cmp: 'MultiSelect',
    props: {
      options: '$attrs.options',
      inputId: '$id',
      display: '$attrs.display',
      modelValue: '$_value',
      showToggleAll: false,
      /**
       * There seems to be an issue with the value for appendTo,
       * `body` is documented to append the selection to the page
       * while `self`, to target, but it seems to be working vise-versa.
       */
      appendTo: 'body',
      class: '$attrs.class',
      onChange: '$handlers.update',
      onBlur: '$handlers.blur',
      placeholder: '$attrs.placeholder',
      optionLabel: (value: MaybeRef<string | FormKitOptionsItem>) => {
        if (typeof unref(value) === 'object')
          return unref(value as FormKitOptionsItem).label

        return value
      },
      optionValue: (value: MaybeRef<string | FormKitOptionsItem>) => {
        if (typeof unref(value) === 'object')
          return unref(value as FormKitOptionsItem).value

        return value
      },
    },
  },
  {
    features: [
      (node) => {
        node.on('created', () => {
          node.context!.handlers.update = (input: any | Array<any>) => {
            if (Array.isArray(input)) node.input(input, false).then(() => null)
            else node.input(input.value, false).then(() => null)
          }
        })
      },
    ],
  },
)
